import type { PushSubscribeRequest } from '@olimhub/shared'
import { apiClient } from '../client'

export const pushApi = {
  getVapidPublicKey: () =>
    apiClient.get<{ publicKey: string | undefined }>('/push/vapid-public-key').then((r) => r.data.publicKey),

  subscribe: (data: PushSubscribeRequest) =>
    apiClient.post('/push/subscribe', data).then(() => undefined),

  unsubscribe: (endpoint: string) =>
    apiClient.post('/push/unsubscribe', { endpoint }).then(() => undefined),
}
